import React, { useEffect, useRef, useState } from 'react';
import { View, Text } from 'react-native';
import { useTheme } from '../context/themeContext';
import { mountPlanCard } from '../utils/skBilling';

/**
 * Settings → Plan & Billing: Platform's plan card (CC-05 §2). Voice draws nothing
 * about the plan — no tiers, rates, minutes or wallet. Platform's card shows them
 * and opens its own drawer to upgrade, top up or renew.
 */
export default function PlanCardPanel() {
  const { theme } = useTheme();
  const host = useRef<View>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const el = host.current as unknown as HTMLElement | null;
    if (el) mountPlanCard(el).catch(() => setFailed(true));
  }, []);

  if (failed) {
    return (
      <Text style={{ fontSize: 12.5, color: theme.colors.ink3, fontFamily: theme.font.sans }}>
        The plan could not be loaded. Refresh the page to try again.
      </Text>
    );
  }
  return <View ref={host} style={{ width: '100%', maxWidth: 880, minHeight: 240 }} />;
}
